import { useEffect, useRef, useState } from "react";
import "./index.scss";
import ChromaKeyVideo from "../ChromaKeyVideo";
import { ClipLoader } from "react-spinners";

const Intro = ({ source, avatar, setSubmittedName, setFirstVisit, isSubmitLoading, setSubmitloading, language, handleSendMessage, idleURL }) => {
  const [currentScene, setCurrentScene] = useState(0);
  const [currentSceneVideo, setCurrentSceneVideo] = useState(0);
  const [userName, setUserName] = useState("");
  const videoRef = useRef(null);
  const nextVideoRef = useRef(null);
  const [isVideoShow, setVideoShow] = useState(true);
  const [isAnotherVideoShow, setAnotherVideoShow] = useState(false);

  const messages = [
    {
      message: `welcome to star enterprise network! my name is ${avatar}.`,
      message_id: `Selamat datang di jaringan perusahaan Star! Nama saya ${avatar}`,
      showSkip: true,
      showNameInput: false,
      isLoop: false,
      duration: avatar === "Hanna" ? 5000 : 5500,
    },
    {
      message: "I will be your assistant for any of your enquiries...",
      message_id: "Saya adalah asisten yang akan membantu menjawab pertanyaan - pertanyaan dari Anda",
      showSkip: true,
      showNameInput: false,
      isLoop: false,
      duration: avatar === "Hanna" ? 7000 : 5500,
    },
    {
      message: "Reconnecting...",
      message_id: "Menghubungkan ulang...",
      showSkip: false,
      showNameInput: false,
      isLoop: false,
      duration: 4000,
    },
    {
      message: "Sorry bad reception due to cosmic rain here, let me welcome you again..",
      message_id: "Maaf, koneksi kurang bagus di sini karena hujan kosmik. Izinkan saya menyambutmu lagi",
      showSkip: true,
      showNameInput: false,
      isLoop: false,
      duration: avatar === "Hanna" ? 7000 : 5500,
    },
    {
      message: `Hi, how can I address you?`,
      message_id: "Halo, bagaimana saya dapat memanggil Anda?",
      showSkip: false,
      showNameInput: true,
      isLoop: false,
      duration: 5000,
    },
  ];

  const videos = [
    {
      video: `${process.env.PUBLIC_URL}/assets/video-avatar/welcome_${avatar}_en.mp4`,
      nextVideo: `${process.env.PUBLIC_URL}/assets/video-avatar/i_will_${avatar}_en.mp4`,
      video_id: `${process.env.PUBLIC_URL}/assets/video-avatar/welcome_${avatar}_id.mp4`,
      nextVideo_id: `${process.env.PUBLIC_URL}/assets/video-avatar/i_will_${avatar}_id.mp4`,
    },
    {
      video: `${process.env.PUBLIC_URL}/assets/video-avatar/glitch_${avatar}.mp4`,
      nextVideo: `${process.env.PUBLIC_URL}/assets/video-avatar/i_will_${avatar}_en.mp4`,
      video_id: `${process.env.PUBLIC_URL}/assets/video-avatar/glitch_${avatar}.mp4`,
      nextVideo_id: `${process.env.PUBLIC_URL}/assets/video-avatar/i_will_${avatar}_id.mp4`,
    },
    {
      video: `${process.env.PUBLIC_URL}/assets/video-avatar/glitch_${avatar}.mp4`,
      nextVideo: `${process.env.PUBLIC_URL}/assets/video-avatar/sorry_${avatar}_en.mp4`,
      video_id: `${process.env.PUBLIC_URL}/assets/video-avatar/glitch_${avatar}.mp4`,
      nextVideo_id: `${process.env.PUBLIC_URL}/assets/video-avatar/sorry_${avatar}_id.mp4`,
    },
    {
      video: `${process.env.PUBLIC_URL}/assets/video-avatar/hi_${avatar}_en.mp4`,
      nextVideo: `${process.env.PUBLIC_URL}/assets/video-avatar/sorry_${avatar}_en.mp4`,
      video_id: `${process.env.PUBLIC_URL}/assets/video-avatar/hi_${avatar}_id.mp4`,
      nextVideo_id: `${process.env.PUBLIC_URL}/assets/video-avatar/sorry_${avatar}_id.mp4`,
    },
    {
      video: `${process.env.PUBLIC_URL}/assets/video-avatar/hi_${avatar}_en.mp4`,
      nextVideo: idleURL,
      video_id: `${process.env.PUBLIC_URL}/assets/video-avatar/hi_${avatar}_id.mp4`,
      nextVideo_id: idleURL,
    },
  ];

  const { message, message_id, showSkip, showNameInput, isLoop, duration } = messages[currentScene] || messages[4];
  const { video, nextVideo, video_id, nextVideo_id } = videos[currentSceneVideo] || { video: idleURL, nextVideo: idleURL };

  const handleSubmitName = (e) => {
    e.preventDefault();
    setSubmitloading(true);
    localStorage.setItem('username', userName);
    setSubmittedName(userName);
    handleSendMessage(language === "english" ? `Hi, my name is ${userName}` : `Halo, nama saya ${userName}`);
    setFirstVisit(false);
  };

  const handleSkip = () => {
    const storedName = localStorage.getItem("username") || "You";
    setSubmittedName(storedName);
    handleSendMessage(language === "english" ? `Hi, my name is ${storedName}` : `Halo, nama saya ${storedName}`);
    setFirstVisit(false);
  };

  const preloadVideos = () => {
    const videoSources = videos.flatMap(video => [
      video.video,
      video.nextVideo,
      video.video_id,
      video.nextVideo_id
    ]);

    videoSources.forEach(src => {
      const videoElement = document.createElement('video');
      videoElement.src = src;
      videoElement.load();
    });
  };

  useEffect(() => {
    preloadVideos();
  }, []);

  useEffect(() => {
    if (currentScene === 0) videoRef.current.play();

    const timeout = setTimeout(() => {
      setCurrentSceneVideo((prev) => prev + 1);
      setVideoShow((prev) => !prev);
      setAnotherVideoShow((prev) => !prev);
      setCurrentScene((prev) => prev + 1);
      (isVideoShow ? nextVideoRef : videoRef).current?.play();
    }, duration);

    return () => clearTimeout(timeout);
  }, [currentScene, duration, isVideoShow]);

  return (
    <div className="intro">
      <video
        className={`chroma-video ${isVideoShow ? 'show' : 'hide'}`}
        ref={videoRef}
        src={language === "english" ? video : video_id}
        loop={isLoop}
        autoPlay={false}
        avatar={avatar}
        playsInline={true}
      />
      <video
        className={`chroma-video ${isAnotherVideoShow ? 'show' : 'hide'}`}
        ref={nextVideoRef}
        src={language === "english" ? nextVideo : nextVideo_id}
        loop={isLoop}
        autoPlay={false}
        avatar={avatar}
        playsInline={true}
      />
      <div className="homepage__intro-popup">
        <div className={`homepage__intro-popup--container ${source}`}>
          <img className="bg-popup--message" src={`${process.env.PUBLIC_URL}/assets/bg-popup-message.png`} alt="" />
          <p className="popup-message">{language === "english" ? message : message_id}</p>
          {showNameInput && (
            <form className="input-name" onSubmit={handleSubmitName}>
              <input
                type="text"
                placeholder={language === "english" ? "Enter your name" : "Ketik namamu di sini"}
                value={userName}
                pattern="[A-Za-z\s]*"
                maxLength="20"
                title="Only letters and space are allowed"
                onChange={(e) => setUserName(e.target.value)}
                required
              />
              <button type="submit">
                {isSubmitLoading ? <ClipLoader color="#fff" size={16} /> : <img src={`${process.env.PUBLIC_URL}/assets/submit.svg`} alt="Submit" />}
              </button>
            </form>
          )}
          {showSkip && (
            <div className="popup__skip-button" onClick={handleSkip}>
              {language === "english" ? "skip" : "lewati"}
            </div>
          )}
        </div>
      </div>
      <div className="intro-overlay"></div>
    </div>
  );
};

export default Intro;
